<div class="step last-transaction"><span>{{ value[0] }}</span></div>
